import { CashFlow, NewCashFlow } from '@api/CashFlows/CashFlow';
import CashFlowServ from '@api/CashFlows/CashFlowServ';
class CashFlowsService {
    saveCashFlow = (cashFlow: NewCashFlow): Promise<CashFlow> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await CashFlowServ.saveCashFlow(cashFlow);
                resolve(data);
            } catch (error) {
                reject('Error saving cash flow: ' + error);
            }
        });
    };
    getCashFlows = (startDate: Date, endDate: Date, branchOfficeId?: string): Promise<CashFlow[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await CashFlowServ.getCashFlows(startDate, endDate, branchOfficeId);
                resolve(data);
            } catch (error) {
                reject('Error getting cash flows: ' + error);
            }
        });
    };
    getCashFlow = (cashFlowId: string): Promise<CashFlow> => {
        return new Promise(async (resolve, reject) => {
            try {
                const cashFlow = await CashFlowServ.getCashFlow(cashFlowId);
                resolve(cashFlow);
            } catch (error) {
                reject('Error getting cash flow: ' + error);
            }
        });
    };

    deleteCashFlow = (cashFlowId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await CashFlowServ.deleteCashFlow(cashFlowId);
                resolve();
            } catch (error) {
                reject('Error deleting cash flow: ' + error);
            }
        });
    };
}
export default CashFlowsService;
